import { render, staticRenderFns } from "./BlockListAccordion.vue?vue&type=template&id=f6926128&"
import script from "./BlockListAccordion.vue?vue&type=script&lang=js&"
export * from "./BlockListAccordion.vue?vue&type=script&lang=js&"
import style0 from "./BlockListAccordion.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports